import React, { useState } from 'react';
import cx from 'classnames';
import { Icon } from 'js/components';
import ReactMarkdown from 'react-markdown';
import { Button, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import AssessmentTypeGlyph from './AssessmentTypeGlyph';
import { faPersonFromPortal } from '@fortawesome/pro-regular-svg-icons';

const renderType = (template) => {
  switch (template.type) {
    case 'live-assessment':
    case 'live':
      // prettier-ignore
      return (
        <>
          <div className={`assessment-template-image ${template.type}`}>
            <AssessmentTypeGlyph type={template.type} />
          </div>
          <div className="assessment-template-type-name">
            Live
          </div>
        </>
      );

    case 'survey':
      // prettier-ignore
      return (
          <>
            <div className={`assessment-template-image ${template.type}`}>
              <AssessmentTypeGlyph type={template.type} />
            </div>
            <div className="assessment-template-type-name">
              Survey
            </div>
          </>
        );

    default:
    // passthrough
  }
};

const CreateAssessmentTemplate = ({ template, onSelect }) => {
  const [showMore, setShowMore] = useState(false);

  const { name, author_name, description } = template;

  const typeComponent = renderType(template);

  const urlKey = template.is_json ? template.key : template.id;

  return (
    <Card className="assessment-template">
      <CardBody>
        <div
          className={cx('assessment-template-visibility', {
            'assessment-template-public': template.is_public,
          })}
        />

        <div className="assessment-template-content">
          <div className="action-items d-none d-sm-block">
            <Link to={`${urlKey}/new`} className="btn btn-primary">
              <span>
                <Icon
                  className="btn-icon-left"
                  icon={faPersonFromPortal}
                  size="lg"
                />
                Get started
              </span>
            </Link>
          </div>
          <div className="assessment-template-type d-none d-sm-block">
            {typeComponent}
          </div>
          <div className="assessment-template-details">
            <div className="assessment-template-type d-block d-sm-none">
              {typeComponent}
            </div>
            <h3 className="assessment-template-name">{name}</h3>
            {showMore ? (
              <div className="assessment-template-more">
                <label>Created By</label>
                <p className="assessment-template-author">{author_name}</p>
                <label>Description</label>
                <div className="assessment-template-description">
                  <ReactMarkdown>{description}</ReactMarkdown>
                </div>
              </div>
            ) : (
              <div className="assessment-template-short-description">
                <ReactMarkdown>
                  {template.short_description ?? template.description}
                </ReactMarkdown>
              </div>
            )}
            <div>
              <button
                onClick={() => setShowMore(!showMore)}
                className="btn btn-link btn-info btn-inline ml-0"
              >
                {showMore ? 'Less' : 'More'}
              </button>
            </div>
          </div>
        </div>
        <div className="action-items mobile d-block d-sm-none">
          <Button color="primary" size="lg" block>
            Continue <Icon className="btn-icon-right" icon="arrow-right" />
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

CreateAssessmentTemplate.defaultProps = {
  onSelect: () => {},
};

export default CreateAssessmentTemplate;
